import type { ICartProduct } from '@/types';

import {
  hydrateServerCartLine,
  stubCartProductFromServerLine,
} from './hydrate-server-cart-line';
import type { ServerCartLine } from './cart-sync.types';

function parseTime(iso?: string): number {
  if (!iso) return 0;
  const t = Date.parse(iso);
  return Number.isFinite(t) ? t : 0;
}

export async function mergeLocalAndServerCart(
  localItems: ICartProduct[],
  serverLines: ServerCartLine[],
  language: string,
): Promise<ICartProduct[]> {
  const localBySku = new Map(localItems.map((i) => [i.id, i]));
  const serverBySku = new Map(serverLines.map((l) => [l.sku, l]));
  const allSkus = [...new Set([...localBySku.keys(), ...serverBySku.keys()])];
  const out: ICartProduct[] = [];

  for (const sku of allSkus) {
    const L = localBySku.get(sku);
    const S = serverBySku.get(sku);

    if (L && !S) {
      out.push(L);
      continue;
    }

    if (!L && S) {
      const built = await hydrateServerCartLine(S, language);
      out.push(built ?? stubCartProductFromServerLine(S, language));
      continue;
    }

    if (L && S) {
      const tL = parseTime(L.cart_line_updated_at);
      const tS = parseTime(S.last_modified_at);
      if (tS > tL) {
        const built = await hydrateServerCartLine(S, language);
        out.push(built ?? stubCartProductFromServerLine(S, language));
      } else {
        out.push(L);
      }
    }
  }

  return out;
}
